import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import CoberturasForm from './coberturas-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import CoberturasTable from './coberturas-table';
import {error, success} from '../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {getFileName} from '../../../utils/utils';

interface CoberturasState {
    coberturas: mirana.IPlanCobertura[];
    periodo?: string;
}

class Coberturas extends React.PureComponent<ReduxProps, CoberturasState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            coberturas: []
        };

        this.handleFiltrar = this.handleFiltrar.bind(this);
        this.handleDescargar = this.handleDescargar.bind(this);
    };

    public async handleFiltrar(values) {

        try {
            const periodo = values.periodo ? values.periodo.value : '';
            const response = await this.apiClient.filtrarCoberturas(values.periodo ? values.periodo.value : '');
            this.setState({
                coberturas: response.coberturas,
                periodo,
            });
            this.props.dispatch(success('Notificación', `Registros encontrados: ${this.state.coberturas.length}`));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar coberturas'));
        }
    }

    public async handleDescargar() {
        const {periodo} = this.state;
        if (periodo) {
            const response = await this.apiClient.descargarCoberturas(periodo);
            fileDownload(response.data, getFileName(response));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Coberturas</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <CoberturasForm onSubmit={this.handleFiltrar}/>
                    </Col>
                    <Col md={9}>
                        <CoberturasTable handleDescargar={this.handleDescargar}
                                         coberturas={this.state.coberturas}
                                         periodo={this.state.periodo}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(Coberturas);



// WEBPACK FOOTER //
// ./src/components/pages/coberturas/coberturas.tsx